import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { theme } from 'theme';

export const StyledStatusPanel = styled(Box)`
  border-radius: 8px;
  border: 1px solid #959595;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.05);
  & .panel_header {
    padding: 18px 31px 17px;
    background-color: ${theme.palette.primary.light};
  }
  & .panel_body {
    padding: 25px 42px;
    flex-direction: row;
    justify-content: space-between;
    gap: 20px;
    overflow: auto;
    ${theme.breakpoints.down('sm')} {
      gap: 10px;
      padding: 25px 20px;
    }
  }
`;

export const StyledStepper = styled(Box)`
  flex: 1;
  height: 1px;
  min-width: 50px;
  border-bottom: 1px solid #b6b6b6;
  position: relative;
  top: 12px;
  margin: 0 -10px;
  &.active {
    border-bottom: 1px solid ${theme.palette.primary.main};
  }
  ${theme.breakpoints.down('sm')} {
    min-width: 20px;
  }
`;
